export const BUILD_INFO = {
  buildNumber: '02112026144611+0530D',
  environment: 'DEV'
};